import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {ReasonCodeEntityModel} from "../reason-code-entity.model";
import {Config} from "../../../config";
import {ReasonCodeData} from "../reason-code.data";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "reason-code-edit-page",
    templateUrl: "./reason-code-edit-page.component.html",
    providers: [provideEntityModel(ReasonCodeEntityModel)]
})
export class ReasonCodeEditPageComponent extends AbstractEditPage {
    Config = Config;

    constructor(public model: ReasonCodeEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    addingAnother(previousEntity: ReasonCodeData): void {
        this.model.data.codeType = previousEntity.codeType;
    }
}
